export default __webpack_public_path__ + "static/media/downloadIcon.e64eee12.svg";